<template>
  <page :manualInit="agencyReportsState.init" :manualErr="agencyReportsState.initErr" @reload="doInit">
    <div v-if="renderReportType">
      <v-subheader>{{labels.reportType}}</v-subheader>
      <v-container fluid grid-list-lg class="mb-3">
        <v-layout row wrap>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['motorSalesPerformance', 'motorTransaction', 'motorDeclineList', 'motorExceptional', 'motorMthlyStats', 'motorApprovedProposal', 'motorPrintQuote', 'motorPrintCN'])">
            <v-card :class="isMatchRoute('motorAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'motorAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MOTOR}}</v-icon>
                <span>Motor</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['travelPrintCertificate', 'travelDailyTransaction', 'travelReconciliation', 'travelPerformance', 'travelExceptional'])">
            <v-card :class="isMatchRoute('travelAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'travelAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.TRAVEL}}</v-icon>
                <span>Travel</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['firePrintCertificate', 'fireTransaction', 'firePerformance', 'fireReconciliation', 'fireExceptional', 'fireMthlyStats'])">
            <v-card :class="isMatchRoute('fireAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'fireAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.FIRE}}</v-icon>
                <span>Fire</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['paPrintCertificate', 'paDailyTransaction', 'paPerformance', 'paReconciliation', 'paExceptional', 'paMthlyStats'])">
            <v-card :class="isMatchRoute('paAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'paAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PA}}</v-icon>
                <span>Personal Accident</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['cargoPrintCN'])">
            <v-card :class="isMatchRoute('cargoAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'cargoAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.CARGO}}</v-icon>
                <span>Cargo</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['maidPrintCertificate', 'maidTransaction', 'maidPerformance', 'maidReconciliation', 'maidExceptional', 'maidMthlyStats'])">
            <v-card :class="isMatchRoute('maidAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'maidAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.MAID}}</v-icon>
                <span>Maid</span>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex lg2 md3 xs6 v-if="checkAccess(['packagePrintCN', 'packageTransaction', 'packageExceptional', 'packageSummary', 'packageMthlyStats'])">
            <v-card :class="isMatchRoute('packageAgencyReports') ? 'quoteCard cardActive' : 'quoteCard'" @click.native="$router.push({ name: 'packageAgencyReports' })">
              <v-layout fill-height column justify-center align-center>
                <v-icon>{{appIcon.PACKAGE}}</v-icon>
                <span>Package</span>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </div>
    <transition name="slide-x-transition" mode="out-in">
      <router-view ></router-view>
    </transition>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import { appIcon } from '@/const/underwriting'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      labels: {
        reportType: 'Report Type'
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    agencyReportsState() {
      return this.$store.state.reports.agencyReports
    },
    renderReportType() {
      if (this.isMatchRouteExact('agencyReports')) {
        return true
      } else {
        return false
      }
    },
    appIcon() {
      return appIcon
    }
  },
  methods: {
    doInit() {
      this.$store.dispatch('agencyReportsInit')
    }
  },
  mounted() {
    if (this.agencyReportsState.init !== 1) {
      this.doInit()
    }
  },
  mixins: [
    routeMixin
  ]
}
</script>

<style lang="scss">
@import "../../../assets/scss/agency.scss";
</style>
